import { useEffect } from 'react'
import {
  AppBar,
  Box,
  Toolbar,
  MenuItem,
  Button,
  Divider,
  Typography,
} from '@mui/material'
import { useAuth } from './AuthContext.tsx'
import { Link, useOutlet, useNavigate } from 'react-router-dom'
import LoginPage from './Loginpage.tsx'
import MenuButton from './MenuButton.tsx'
import { IssueButton } from './IssueTracker/Button.tsx'

async function check() {
  const resp = await fetch('/oauth2/userinfo')
  if (resp.status == 401) {
    return false
  } else if (resp.ok) {
    return true
  } else {
    console.error(`In auth got ${resp.status}`)
    return false
  }
}
const App = () => {
  const navigate = useNavigate()
  const { isLoggedIn, logout, login } = useAuth()

  useEffect(() => {
    if (!isLoggedIn) {
      check().then((resp) => {
        if (resp) {
          login()
        }
      })
    }
  }, [isLoggedIn])
  const outlet = useOutlet()
  if (isLoggedIn)
    return (
      <Box>
        <Box position="fixed" sx={{ height: '64px' }}>
          <AppBar position="fixed">
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box>
                <Button variant="contained" onClick={() => navigate('/prism')}>
                  PRISM
                </Button>
                <MenuButton buttonName="Plant P/L" variant="contained">
                  <MenuItem disabled>
                    <Typography variant="h6" align="left">
                      PJM
                    </Typography>
                  </MenuItem>
                  <MenuItem component={Link} to="/plants/fern">
                    Fern
                  </MenuItem>
                  {/* <MenuItem disabled>Camden (coming soon)</MenuItem> */}
                  <Divider />
                  <MenuItem disabled>
                    <Typography variant="h6" align="left">
                      ERCOT
                    </Typography>
                  </MenuItem>
                  {/* <MenuItem component={Link} to="/plants/amadeus">
                    Amadeus
                  </MenuItem> */}
                </MenuButton>
                <MenuButton variant="contained" buttonName="Commercial">
                  <MenuItem component={Link} to="/compare">
                    Curve Comparison
                  </MenuItem>
                  <MenuItem
                    onClick={() => (window.location.pathname = '/ai/dashboard')}
                  >
                    Commercial Hub
                  </MenuItem>
                </MenuButton>
                {/* <Button variant="contained" onClick={menuCommClick}>
              Maps ()
            </Button> */}
                <Button variant="contained" onClick={() => navigate('/map')}>
                  Map
                </Button>
                <Button variant="contained" onClick={() => navigate('/newmap')}>
                  New Map
                </Button>
                <Button variant="contained" onClick={() => navigate('/issues')}>
                  Issues
                </Button>
              </Box>
              <Button
                variant="contained"
                // onClick={() => navigate('/oauth2/sign_out')}
                onClick={() => {
                  logout()
                  window.location.pathname = '/oauth2/sign_out'
                }}
              >
                Sign Out
              </Button>
            </Toolbar>
          </AppBar>
        </Box>
        <Box
          sx={{
            position: 'fixed',
            top: '64px',
            height: 'calc(100vh - 64px)',
            width: '100vw',
            backgroundColor: 'background.default',
            overflow: 'auto',
          }}
        >
          {
            outlet // || <PlaceHolder/>
          }
        </Box>
        <IssueButton />
      </Box>
    )
  return <LoginPage />
}

export default App
